import { FeatureFlags } from 'src/shared/enums/feature-flags.enum';

const tenantName = 'joyfoodsyn';
const CLIENT_ID = '006ce655-a878-488c-8830-7b5ff62ff3a0';
const API_ID = '683f018e-4d5b-4a0a-bbfa-ba28317f3532';

export const environment = {
  production: false,
  featureFlags: {
    [FeatureFlags.WORLDLINE]: true,
  },
  msalConfig: {
    auth: {
      clientId: CLIENT_ID,
      authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1A_SIGNUP_USERNAMEOREMAIL`,
      knownAuthorities: [`${tenantName}.b2clogin.com`],
      scopes: [
        `https://${tenantName}.onmicrosoft.com/${API_ID}/fullaccess`,
        'offline_access',
        'openid',
      ],
      redirectUri: 'https://app.dev.joyfoodplus.elior.com',
      postLogoutRedirectUri: 'https://app.dev.joyfoodplus.elior.com',
    },
  },
  apiConfig: {
    webApiUri: 'https://api.mobile.dev.joyfoodplus.elior.com',
  },
  language: 'en',
  termsAndConditionsLink:
    'https://www.elior.it/termini-e-condizioni/joyfoodplus',
  privacyPolicyLink:
    'https://www.elior.it/informativa-sul-trattamento-dei-dati-personali',
  wordline: {
    worldlineApiKey: '1MAFBM0-DRH47KJ-QBQ3551-X1FNN13',
    worldlineApiUri: 'https://pay-sandbox.worldlineitalia.it',
  }
};
